import { render, staticRenderFns } from "./LabCatalog.vue?vue&type=template&id=7e77799c&scoped=true&lang=pug"
import script from "./LabCatalog.vue?vue&type=script&lang=js"
export * from "./LabCatalog.vue?vue&type=script&lang=js"
import style0 from "./LabCatalog.vue?vue&type=style&index=0&id=7e77799c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e77799c",
  null
  
)

export default component.exports